var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.$route.name !== "gym.live" && _vm.livestreamOnline,
          expression: "$route.name !== 'gym.live' && livestreamOnline"
        }
      ],
      staticClass: "card shadow-lg mb-5 border border-danger"
    },
    [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-11" },
            [
              _c("p", [
                _c("span", { staticClass: "text-danger font-weight-bolder" }, [
                  _vm._v("[LIVE]")
                ]),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("live.alert")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-dark btn-sm",
                  attrs: { tag: "button", to: { name: "gym.live" } }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("live.watch_now")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-1" }, [
      _c("i", {
        staticClass: "mdi mdi-record-circle-outline mdi-48px text-danger shaky"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }